// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import './plugins/vuetify'

import App from './App'
import router from './router'

import db from './db'
import store from './store'

Vue.config.productionTip = false

const settings = {}
db.settings(settings)

window.addEventListener('load', function () {
  // initApp()
})

if ('speechSynthesis' in window) {
  // intentionally unused variable...just priming up speechSynthesis
  speechSynthesis.getVoices()
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js